import { motion } from 'framer-motion'
import { Check, Code, Database, Globe, Shield } from 'react-feather'
import { Link } from 'react-router-dom'
import AnimatedBackground from '../common/AnimatedBackground'
import './ServiceDetail.css'

export default function WebDevelopment() {
  const technologies = [
    "React", "Next.js", "Node.js", "TypeScript",
    "PostgreSQL", "MongoDB", "AWS", "Docker"
  ]

  const features = [
    {
      icon: Code,
      title: "Custom Web Applications",
      description: "Tailored solutions built with modern frameworks and best practices."
    },
    {
      icon: Globe,
      title: "Responsive Design",
      description: "Websites that work flawlessly across all devices and screen sizes."
    },
    {
      icon: Database,
      title: "API Development",
      description: "Robust and scalable APIs to power your web applications."
    },
    {
      icon: Shield,
      title: "Security First",
      description: "Implementation of best security practices and regular updates."
    }
  ]

  return (
    <section className="service-detail-section">
      <AnimatedBackground text="" />
      <div className="service-detail-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="service-detail-header"
        >
          <h1>Web <span className="gradient-text">Development</span></h1>
          <p>Creating powerful web experiences that drive business growth</p>
        </motion.div>

        <div className="service-content">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="service-description"
          >
            <h2>What We Offer</h2>
            <p>
              Our web development services combine cutting-edge technology with 
              creative design to deliver exceptional digital experiences. We focus 
              on creating scalable, secure, and high-performance web applications 
              that help businesses thrive in the digital age.
            </p>
          </motion.div>

          <div className="features-grid">
            {features.map((feature, index) => {
              const Icon = feature.icon
              return (
                <motion.div
                  key={feature.title}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 + index * 0.1 }}
                  className="feature-card"
                >
                  <Icon className="feature-icon" />
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </motion.div>
              )
            })}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="technologies-section"
          >
            <h2>Technologies We Use</h2>
            <div className="technologies-grid">
              {technologies.map((tech, index) => (
                <div key={tech} className="technology-item">
                  <Check className="check-icon" />
                  <span>{tech}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
            className="cta-section"
          >
            <h2>Ready to Start Your Project?</h2>
            <p>Let's discuss how we can help bring your vision to life.</p>
            <Link to="/contact" className="cta-button">
              Get in Touch
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

